/*
 * @Descripttion:
 * @version:
 * @Author: Andy
 * @Date: 2022-08-23 13:27:26
 * @LastEditors: Andy
 * @LastEditTime: 2023-03-21 12:19:09
 */
import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { axiosQuick } from '@idev0/vue-axios'
import VueCompositionAPI from '@vue/composition-api'
import data from './api'
import views from './views'
import SvgIcon from '@/components/icon.vue'
// 引入vxe-table
import './utils/register-vxe.js'

import { fitChartSize } from './utils/fitChartSize'

import { init } from '@idev0/bee-core'

import '@wushi/lethe-map/lib/lethe-map.css'
import LetheMap from '@wushi/lethe-map'
import './utils/global-use.utils.js'
import './utils/leaflet-polygon.fillPattern.js'

import './styles/reset.scss'
import './styles/font/font.css'
// import 'echarts-liquidfill'

import './utils/flexible.js'
import './utils/overwride.js'
import { GLOBAL_CONFIG } from '../public/config'
// import '@/utils/flexible.js'
// import '@lethe/components/es/index.css'
// import LetheComponents from '@lethe/components'
Vue.use(LetheMap)

Vue.prototype.$fitChartSize = fitChartSize
Vue.config.productionTip = false
Vue.prototype.$GLOBAL_CONFIG = GLOBAL_CONFIG
// Vue.prototype.$wmsLayerUrl =
// process.env.NODE_ENV === 'production' ? 'https://www.fjscyzgl.com/mapserver/aquaculture/wms' : ''
// 测试用
// Vue.prototype.$wmsLayerUrl =
//   process.env.NODE_ENV !== 'production'
//     ? 'http://code01.gdhqx.com:1257/mapserver/aquaculture/wms'
//     : ''
// process.env.NODE_ENV !== 'production' && require('./mock')

Vue.use(VueCompositionAPI)
Vue.component('svg-icon', SvgIcon)

const config = {
  apiConfig: data, // 也可以直接通过url获取，url: '/web/config/system_api.json',
  router,
  paramSign: true,
  requestIntercept (config) {
    return config
  }
}

axiosQuick(config).then(() => {
  init(
    store,
    router,
    views,
    {
      beforeVueMounted (params) {
        const options = Object.assign({}, params, { render: h => h(App) })
        new Vue(options).$mount('#app')
      }
      // 如果要加载bi大屏
      // import { initDashboard } from '@idev0/bee-dashboard'
      // afterInitRouter (s, r, v) {
      //   initDashboard(s, r, v)
      // }
    },
    {
      subDirectory: null // 如果后台是二级目录部署的，可以配置二级目录地址，如 /acm
    }
  )
})
